import { Component, OnInit, Output, EventEmitter, ElementRef, HostListener } from '@angular/core';
import { AccountContact } from 'src/app/core/models/account-contact';
import { HomeService } from 'src/app/core/services/home.service';
import { UserDataService } from 'src/app/core/services/user-data.service';
import { MatDialog } from '@angular/material/dialog';
import { CustomerTrainingComponent } from '../customer-training/customer-training.component';
import { CustomerTrainingService } from 'src/app/core/services/customer-training.service';
import { NavigationEnd, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { finalize, map } from 'rxjs';
import { Department } from '../../models/department';

@Component({
  selector: 'help-center',
  templateUrl: './help-center.component.html',
  styleUrls: ['./help-center.component.scss'],
  standalone: false,
})
export class HelpCenterComponent implements OnInit {
  @Output() closeEvent = new EventEmitter<boolean>();

  // Store FAQ
  questions: FAQ[] = [];

  // Used to close the help center when the user clicks outside
  isHelpCenterOpen = true;

  // True if is fetching customer training
  isFetchingQuestions: boolean = true;

  // True if current page has a customer training material
  customerTraining: boolean = false;

  // Used to check if there is customer training on component load
  isFirstLoad: boolean = true;

  // True if is fetching contacts by departments
  isLoadingDepartments: boolean = false;

  // True if is fetching contacts by departments
  showContactsCard: boolean = true;

  // Store the departments and its contacts
  departments: Department[] = [];

  // Departments order based on hub path
  modulesDepartments = {
    orders: ['customer support', 'sales ops', 'sales'],
    support: ['customer support', 'warranty support'],
    other: ['customer support'],
  };

  get contacts(): AccountContact[] {
    return this.userData.company.contacts;
  }

  constructor(
    private homeService: HomeService,
    private userData: UserDataService,
    private matDialog: MatDialog,
    private customerTrainingService: CustomerTrainingService,
    private router: Router,
    private eRef: ElementRef,
    private http: HttpClient,
  ) {}

  ngOnInit(): void {
    this.homeService.getFaq().subscribe((faq: FAQ[]) => {
      this.questions = faq;
      this.isFetchingQuestions = false;
    });

    if (this.isFirstLoad) {
      this.isFirstLoad = false;
      this.checkIfCustomerTraining();
    }

    // run when route changes
    this.router.events.subscribe((value) => {
      if (value instanceof NavigationEnd) {
        this.checkIfCustomerTraining();
      }
    });

    this.fetchDepartmentContacts();
  }

  //update

  // @HostListener('document:click', ['$event'])
  // clickout(event) {
  //   if(!this.eRef.nativeElement.contains(event.target) && event.target.innerText !== '?' && this.isHelpCenterOpen) {
  //     this.closeHelpCenter();
  //   }
  // }

  openCustomerTraining(): void {
    this.isHelpCenterOpen = false;
    const dialogRef = this.matDialog.open(CustomerTrainingComponent, {
      data: {
        currentPath: window.location.pathname,
      },
      height: 'auto',
      width: '80vw',
      autoFocus: false,
      panelClass: 'customer-training-dialog',
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.isHelpCenterOpen = true;
    });
  }

  private async checkIfCustomerTraining(): Promise<void> {
    // every route change, set as false to avoid showing it until it checks if there are files
    this.customerTraining = false;

    if (this.customerTrainingService.checkDataExistsForCurrentLocation(window.location.pathname)) {
      this.customerTraining = true;
    }
  }

  private fetchDepartmentContacts() {
    this.isLoadingDepartments = true;

    this.http
      .get<Department[]>(`${environment.restUrl}/v1/hub/support-contacts`)
      .pipe(
        map((departments: Department[]) => {
          if (window.location.pathname.includes('orders')) {
            return this.reorderDepartments('orders', departments);
          } else if (window.location.pathname.includes('support')) {
            return this.reorderDepartments('support', departments);
          } else {
            return this.reorderDepartments('other', departments);
          }
        }),
        finalize(() => (this.isLoadingDepartments = false)),
      )
      .subscribe((departments) => {
        this.departments = departments;
        departments.length === 0 ? (this.showContactsCard = false) : (this.showContactsCard = true);
      });
  }

  /** Reorder departments base on the hub path */
  private reorderDepartments(module: string, departments: Department[]) {
    this.modulesDepartments[module].forEach((item) => {
      const index = departments.findIndex((department) => department.department.toLowerCase() === item);

      if (index !== -1) {
        const element = departments.splice(index, 1);
        departments.unshift(element[0]);
      }
    });

    return departments;
  }

  closeHelpCenter() {
    this.closeEvent.emit(false);
  }
}

interface FAQ {
  question: string;
  answer: string;
}
